import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

type Headers = AxiosResponseHeaders | RawAxiosResponseHeaders;

const getFileName = (disposition: string) => {
  if (disposition?.includes('attachment')) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches?.[1]) {
      return matches[1].replaceAll(/['"]/g, '');
    }
  }

  return undefined;
};

const getDataWithFilenameFromHeader = <T>(data: T, headers: Headers) => {
  return {
    data,
    filename: getFileName(headers['content-disposition'] as string),
  };
};

export const transformResultToDataWithFilename = <T>(data: T, headers: Headers) => {
  return getDataWithFilenameFromHeader(data, headers);
};
